import * as React from 'react';
import TimelineVideo from '../../../../timeline/TimelineVideo/TimelineVideo';

const VideoPreview = require('../../../../../assets/img/timeline/modal/2014-Soft.jpg');

const SoftResultsContent = () => {
    return (
        <>
            <TimelineVideo videoId="pfwXiBDzEzE" imagePreview={VideoPreview} />
            <h4>
                SOFT and TEXT clinical trial results
            </h4>
            <p>
                The results of a combined analysis of the SOFT and TEXT clinical trials show that the aromatase inhibitor, exemestane, is more effective than tamoxifen in preventing breast cancer recurrence in premenopausal women who also receive ovarian function suppression. The results from the SOFT clinical trial showed for women with sufficient risk of recurrence to receive chemotherapy and who subsequently remain premenopausal, that the addition of ovarian function suppression to tamoxifen reduced the risk of breast cancer recurrence. These practice changing results in the treatment of breast cancer in young women, were published in the New England Journal of Medicine. Breast Cancer Trials (BCT) recruited 249 women to TEXT and 240 women to SOFT. Associate Professor Prue Francis is the BCT Study Chair of these trials.
            </p>
        </>
    );
}

export default SoftResultsContent;